export default __webpack_public_path__ + "static/media/list.5276b158.svg";